export const CONSTANTS = {
  FuelAccounting: 'Облік пального',
  Exit: 'Вихід',

  NAVLINKS: [
    { name: 'Заправка', path: '/' },
    { name: 'Бочка', path: '/fuel-tank/1' },
    { name: 'Усі заправки', path: '/fuelings' },
    { name: 'Звіт для бухгалтерії', path: '/accounting-report' },
    { name: 'Ліміти легкових', path: '/car-limits' },
    // { name: 'Розхід по тягачам', path: '/truck-consumption' },
  ],
};
